(function () {
    'use strict';

    angular
        .module('app')
        .directive('paneResize', paneResize);

    paneResize.$inject = ['$window'];

    function paneResize($window) {
        // Usage:
        //     <paneResize></paneResize>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                onResize: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
            //add the handle
            var handle = angular.element('<div class="vertical-handle"></div>');
            var newWidth = 300;
            element.prepend(handle);
            handle[0].addEventListener('touchstart', down);
            handle[0].addEventListener('mousedown', down);

            //mouse/touch down listener
            function down(event) {
                //prevent the default behavior to avoid highlighting text, etc...
                event.preventDefault();

                //add listeners
                document.addEventListener('mouseup', up);
                document.addEventListener('touchend', up);
                document.addEventListener('mousemove', move);
                document.addEventListener('touchmove', touchMove);

                //set the handle styles
                setMoveStyle();
            }

            //mouse/touch up listener
            function up(event) {
                event.preventDefault();
                //remove the listeners
                document.removeEventListener('mousemove', move);
                document.removeEventListener('touchmove', touchMove);
                //set the element's width
                element.css('width', newWidth);
                //reset the handle style to the default values.
                resetHandleStyle();
                //fire the onResize event to notify subscribers
                scope.onResize(newWidth);
            }

            //handle the move event
            function move(event) {
                //set the position of the handle
                setHandlePosition(event.clientX);
            }

            //handle the move event
            function touchMove(event) {
                //get the touch object
                var touchobj = event.changedTouches[0];
                //set the position of the handle
                setHandlePosition(touchobj.clientX);
            }

            function setHandlePosition(position) {
                //calculate the width based on the position of the handle
                newWidth = position - $(element).offset().left;
                //calculate half the parent's width and prevent the size to be above that
                var halfParentWidth = Math.floor(angular.element(element.parent()).width() / 2);
                if (newWidth > halfParentWidth) {
                    newWidth = halfParentWidth - 2;
                }
                //prevent the handle to be move to less than 150 pixels
                if (newWidth < 150)
                    newWidth = 150;
                //set the position of the handle
                handle.css("left", newWidth + "px");
            }

            //default handle styles
            function setMoveStyle() {
                handle.css("border", "1px dotted rgb(140,140,140)");
                handle.css("background-color", "white");
                handle.css("width", "1px");
            }

            //moving handle styles
            function resetHandleStyle() {
                handle.css("border", "");
                handle.css("background-color", "rgb(240,240,240)");
                handle.css("width", "4px");
                handle.css("left", "");
            }
        }
    }

})();